module.exports = __webpack_public_path__ + "static/media/FOTO 3.8.f774951f.jpg";